import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "my-3 text-center"
};
const _hoisted_2 = { class: "me-2" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContextModal',
    props: {
        closeButton: {
            type: String,
            default: null
        },
        zIndex: {
            type: Number,
            default: 1050
        },
        size: {
            type: String,
            default: 'md' // can be 'sm', 'md', 'lg'
        }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const visible = ref(false);
        const position = ref({ x: 0, y: 0 });
        function openAt(x, y) {
            position.value = { x, y };
            visible.value = true;
        }
        function open(event) {
            if (!event) {
                visible.value = true;
                position.value = { x: 0, y: 50 };
                return;
            }
            // Calculate Y position for modal if too close to bottom
            let yPosition = event.clientY;
            if (event.screenY / screen.height > 0.5) {
                yPosition -= 200;
            }
            if (event.screenY / screen.height > 0.6) {
                yPosition -= 300;
            }
            if (event.screenY / screen.height > 0.7) {
                yPosition -= 100;
            }
            if (event.screenY / screen.height > 0.9) {
                yPosition -= 200;
            }
            if (event.clientY < 650) {
                yPosition = 80;
            }
            position.value = { x: event.clientX, y: yPosition };
            visible.value = true;
        }
        function close() {
            visible.value = false;
        }
        __expose({ openAt, open, close });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { duration: 550 }, {
                default: _withCtx(() => [
                    (visible.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "position-fixed top-0 start-0 w-100 h-100 px-3 d-flex justify-content-center align-items-center",
                            onClick: _withModifiers(close, ["self"]),
                            style: _normalizeStyle([{ zIndex: props.zIndex }, { "overflow-y": "auto" }])
                        }, [
                            _createElementVNode("div", {
                                class: "context-modal-content position-absolute border bg-white rounded shadow-lg px-3 px-md-5 pt-5",
                                style: _normalizeStyle({ top: position.value.y + 'px', maxWidth: '100%', width: props.size === 'sm' ? '500px' : props.size === 'lg' ? '1140px' : '1000px' })
                            }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn-close position-absolute top-0 end-0 m-3",
                                    onClick: close
                                }),
                                _renderSlot(_ctx.$slots, "default"),
                                (props.closeButton)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createElementVNode("button", {
                                            class: "btn btn-primary d-inline-flex align-items-center",
                                            onClick: close
                                        }, [
                                            _createElementVNode("span", _hoisted_2, _toDisplayString(props.closeButton), 1),
                                            _cache[0] || (_cache[0] = _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-arrow-right",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                                })
                                            ], -1))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 4)
                        ], 4))
                        : _createCommentVNode("", true)
                ]),
                _: 3
            }));
        };
    }
});
